import React from 'react';
// icons
import { ReactComponent as CloseIcon } from 'assets/icons/close.svg';
// logic
import { useHistory } from 'react-router-dom';
// components
import ToolBarButton from '../ui/toolbar/toolBarButton';
import ToolbarTitle from '../ui/toolbar/toolbarTitle';
import RegularText from '../ui/texts/RegularText';
import ticketService from 'modules/emergencies/ticketService';
import ToolbarContainer from '../ui/containers/toolbarContainer';

const TicketRepeatToolbar = ({ id }) => {
  const history = useHistory();

  return (
    <ToolbarContainer>
      <div>
        <RegularText>Repeat</RegularText>
        <ToolbarTitle>Ticket ID. {ticketService.utils.getFormatedId(id)}</ToolbarTitle>
      </div>
      <ToolBarButton
        onClick={() => {
          history.push('/emergencies/');
        }}
      >
        <CloseIcon />
      </ToolBarButton>
    </ToolbarContainer>
  );
};

export default TicketRepeatToolbar;
